<script setup>
import { computed } from 'vue';

const props = defineProps({
  count: { type: [Number, String], default: 0 },
});

const normalizedCount = computed(() => {
  const count = Number(props.count);
  return Number.isFinite(count) && count > 0 ? count : 0;
});

const displayCount = computed(() =>
  normalizedCount.value > 99 ? '99+' : String(normalizedCount.value)
);
</script>

<template>
  <span
    v-if="normalizedCount > 0"
    data-test-id="sidebar-unread-badge"
    class="chatmigo-sidebar-count inline-grid h-[1.2rem] min-w-[1.2rem] flex-shrink-0 place-items-center rounded-full px-1.5 text-[10px] font-semibold leading-none"
    :class="{ 'chatmigo-sidebar-count--wide': displayCount.length > 2 }"
  >
    {{ displayCount }}
  </span>
  <span v-else class="hidden" />
</template>
